import classnames from 'classnames/bind'
import React from 'react'
import { GlobalThemeColors } from '~/@types/colors'

import Cta, { CtaProps } from '~/components/Abstracts/Cta'
import { DownIcon } from '~/components/UI/Icons'

import css from './styles.module.scss'

const cx = classnames.bind(css)

function SliderArrow({ className, ...rest }: CtaProps) {
  return (
    <Cta
      theme={GlobalThemeColors.Black}
      css={css}
      cx={cx}
      className={cx(className, css.SliderArrow)}
      {...rest}>
      <DownIcon className={cx(css.arrowIcon)} />
    </Cta>
  )
}

SliderArrow.defaultProps = {}

export default SliderArrow
